module.exports = __webpack_public_path__ + "static/Facebookliten-d5151cf0b8a1bf4458c94791e34f9d36.jpg";